import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M33.652 28a1 1 0 1 1 0-2q4.134 0 8.266.67a4 4 0 0 1 3.207 2.853l.622 2.184q.033.117.06.237c.464 2.11-.912 4.187-3.001 4.754a42.5 42.5 0 0 1-6.09 1.158 1 1 0 0 1-.22-1.988 40.5 40.5 0 0 0 5.786-1.1c1.093-.297 1.798-1.362 1.571-2.395l-.03-.118-.621-2.184a2 2 0 0 0-1.604-1.427A49.6 49.6 0 0 0 33.652 28m-4-10c0 2.206 1.793 4 4 4s4-1.793 4-4-1.793-4-4-4-4 1.793-4 4m-2 0c0-3.312 2.69-6 6-6 3.312 0 6 2.69 6 6 0 3.312-2.69 6-6 6-3.312 0-6-2.69-6-6m-10 22c5.717 0 9.866-.535 12.408-1.573a2 2 0 0 0 1.205-2.243l-.778-3.898a5 5 0 0 0-4.48-4.003Q22.689 28 17.653 28t-8.356.283a5 5 0 0 0-4.48 4.003l-.777 3.898a2 2 0 0 0 1.205 2.243C7.786 39.465 11.934 40 17.652 40m0 2c-5.955 0-10.33-.564-13.165-1.722a4 4 0 0 1-2.41-4.485l.778-3.898a7 7 0 0 1 6.272-5.605q3.412-.29 8.525-.29t8.525.29a7 7 0 0 1 6.272 5.605l.777 3.898a4 4 0 0 1-2.41 4.485C27.984 41.436 23.607 42 17.653 42m-6-28c0 3.309 2.69 6 6 6s6-2.69 6-6-2.69-6-6-6-6 2.69-6 6m-2 0c0-4.416 3.587-8 8-8 4.416 0 8 3.587 8 8 0 4.416-3.587 8-8 8-4.416 0-8-3.587-8-8",
      clipRule: "evenodd"
    }
  )
);
var SvgPeopleOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var PeopleOutlined_default = SvgPeopleOutlined;

export { PeopleOutlined_default as default };
